import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClipboard2Sparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clipboard 2-sparkle, copy, list, auto-fill, form-fill"><path d="M7.75 2.75H16.25V7.25H7.75V2.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M18.4 14H17.6L16.6 16.6L14 17.6V18.4L16.6 19.4L17.6 22H18.4L19.4 19.4L22 18.4V17.6L19.4 16.6L18.4 14Z" fill="currentColor"/><path d="M16.25 4.75H20.25V12.5M7.75 4.75H3.75V21.25H14" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconClipboard2Sparkle;
